var map = {
	"./arrow-right.svg": "55b9",
	"./calling.svg": "c3aa",
	"./checked.svg": "1f78",
	"./copy.svg": "c0a5",
	"./emoji.svg": "3b1d",
	"./error.svg": "7518",
	"./exit.svg": "a109",
	"./full-screen.svg": "6d88",
	"./language.svg": "a17a",
	"./layout.svg": "ae30",
	"./pause.svg": "b849",
	"./play.svg": "4c1a",
	"./quit-full-screen.svg": "01c9",
	"./setting.svg": "08d1",
	"./share.svg": "2296"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";